import type { ScopedThreadRef } from "@cmmd-forge/contracts";
import type { RightPanelId } from "../diffRouteSearch";

export function resolveDraftCanonicalThreadRef(input: {
  readonly promotedTo: ScopedThreadRef | null | undefined;
  readonly serverThreadStarted: boolean;
  readonly serverThreadRef: ScopedThreadRef | null;
}): ScopedThreadRef | null {
  if (input.promotedTo) {
    // A persisted thread can contain an admission failure before a provider starts.
    const persistedPromotion =
      input.serverThreadRef?.environmentId === input.promotedTo.environmentId &&
      input.serverThreadRef?.threadId === input.promotedTo.threadId;
    return input.serverThreadStarted || persistedPromotion ? input.promotedTo : null;
  }
  return input.serverThreadRef;
}

export function resolveDraftPreviewPanel(input: {
  readonly requestedPanel: RightPanelId | null | undefined;
}): "preview" | null {
  return input.requestedPanel === "preview" ? "preview" : null;
}

export function filterDraftPreviewTabs(
  tabs: readonly RightPanelId[] | undefined,
  fallbackPanel: "preview" | null,
): "preview"[] {
  return (tabs ?? (fallbackPanel ? [fallbackPanel] : [])).filter(
    (tab): tab is "preview" => tab === "preview",
  );
}

export function shouldRenderDraftRightPanelSurface(input: {
  readonly hasSidebarState: boolean;
  readonly sidebarOpen: boolean;
}): boolean {
  return input.hasSidebarState || input.sidebarOpen;
}
